module.exports = __webpack_public_path__ + "img/cns_android10.14160e40.png";